import script from "./TenderTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TenderTable.vue?vue&type=script&setup=true&lang=js"

import "./TenderTable.vue?vue&type=style&index=0&id=10b23e8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10b23e8a"]])

export default __exports__